<template>
<div class="acomodar">
  
    <RestriccionPostulante/>
</div>
</template>

<script>
import RestriccionPostulante from '@/components/ModSeleccion/Postulante/RestriccionPostulante.vue';
export default {
  name: 'RestriccionPostulante1',
  components: {
   RestriccionPostulante
  },
  data() {
    return {};
  },

  mounted() {},

  created() {
    this.cambiarEstadoNavbar()
  },

  methods: {
    cambiarEstadoNavbar() {
    //   // Acción directa para cambiar el estado del navbar a true
     this.$store.dispatch("acciones/CambioNavbar", true);
     },
  },
};
</script>
<style  scoped>

</style>